import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./index.css";
import { Calendar, Clock, MapPin } from "lucide-react";
import EventDetailsSection from "./components/EventDetailsSection";
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"
import { useEffect } from "react";
import { supabase } from "./lib/supabase";


import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LocationOverlay from "./components/LocationOverlay";
import FocusAreas from "./components/FocusAreas";
import ProgramHighlights from "./components/ProgramHighlights";
import SpeakersSection from "./components/SpeakersSection" 
import Stats from "./components/Stats";
import RegistrationForm from "./components/RegistrationForm";
import Partners from "./components/Partners";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";

import AboutUs from "./pages/AboutUs";
import ClubAfricamed from "./pages/ClubAfricamed";
import Registration from "./pages/Registration";
import SpeakerBio from "./pages/SpeakerBio";
import PrivacyPolicy from "./pages/PrivacyPolicy";

import AdminLogin from "./dashboard/pages/AdminLogin";
import AdminLayout from "./dashboard/layout/AdminLayout";
import DashboardOverview from "./dashboard/pages/DashboardOverview";
import ConferenceRegistrations from "./dashboard/pages/ConferenceRegistrations";
import ClubMemberships from "./dashboard/pages/ClubMemberships";
import Speakers from "./dashboard/pages/Speakers"
import Newsletter from "./dashboard/pages/Newsletter";
import MailSystem from "./dashboard/pages/MailSystem";

//import { AdminRoutes } from "./dashboard/routes/AdminRoutes";
import PaymentValidations from "./dashboard/pages/PaymentValidations";
import AdminGuard from "./components/AdminGuard";

import { Toaster } from "react-hot-toast";
import PartnersSponsors from "./components/PartnersSponsors";

function Home() {
  const eventStartISO = "2026-01-16T08:30:00+01:00";
  const eventEndISO = "2026-01-17T18:00:00+01:00";

  return (
    <>
      {/* Location Overlay - imported as a standalone component */}
      <LocationOverlay />

      <Hero
        eventStartISO={eventStartISO}
        eventEndISO={eventEndISO}
      />

      <EventDetailsSection />

      <FocusAreas />
      <ProgramHighlights />
      <SpeakersSection /> 
      <Stats />
      <Partners />
      <PartnersSponsors />
    </>
  );
}


export default function AfricaSportsForumWebsite() {
  const eventStartISO = "2026-01-16T08:30:00+01:00";
  const eventEndISO = "2026-01-17T18:00:00+01:00";
  const sections = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "program", label: "Program" },
    { id: "speakers", label: "Speakers" },
    { id: "register", label: "Registration" },
    { id: "club", label: "Club Africamed" },
  
  ];

  const location = useLocation();

  // Track page visits
  useEffect(() => {
    const trackVisit = async () => {
      try {
        // Only track non-admin pages
        if (!location.pathname.startsWith('/admin')) {
          // Detect device type from user agent
          const ua = navigator.userAgent;
          let deviceType = 'Desktop';
          if (/Mobile|Android|iPhone|iPad|iPod/i.test(ua)) {
            if (/iPad/i.test(ua)) {
              deviceType = 'Tablet';
            } else {
              deviceType = 'Mobile';
            }
          } else if (/Tablet/i.test(ua)) {
            deviceType = 'Tablet';
          }

          // Get country from a geolocation API (using a free service)
          let country = 'Unknown';
          try {
            const geoResponse = await fetch('https://ipapi.co/json/');
            if (geoResponse.ok) {
              const geoData = await geoResponse.json();
              country = geoData.country_name || 'Unknown';
            }
          } catch (geoError) {
            console.log('Geolocation unavailable');
          }

          await supabase.from('site_visits').insert({
            page_path: location.pathname,
            referrer: document.referrer || null,
            user_agent: navigator.userAgent,
            country: country,
            device_type: deviceType,
          });
        }
      } catch (error) {
        console.error('Analytics tracking error:', error);
      }
    };

    trackVisit();
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-amber-900 to-slate-900 text-white">
      
      <Analytics />
       <SpeedInsights />
      <Toaster position="top-center" />
      <Navbar 
        forumName="Africamed Business Forum" 
        sections={sections} 
        eventStartISO={eventStartISO}
        eventEndISO={eventEndISO}
      />

      <main className="pt-20">
       <Routes>
  {/* Public routes */}
  <Route path="/" element={<Home />} />
  <Route path="/about" element={<AboutUs />} />
  <Route path="/club" element={<ClubAfricamed />} />
  <Route path="/register" element={<Registration />} />
  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
  <Route path="/speaker/:id" element={<SpeakerBio />} />
  <Route path="/admin-login" element={<AdminLogin />} />

  {/* Admin routes */}
  <Route
    path="/admin"
    element={
      <AdminGuard>
        <AdminLayout />
      </AdminGuard>
    }
  >
    <Route index element={<DashboardOverview />} />
    <Route path="conference" element={<ConferenceRegistrations />} />
    <Route path="club" element={<ClubMemberships />} />
     <Route path="payments" element={<PaymentValidations />} />
     <Route path="speakers" element={<Speakers />} />
     <Route path="newsletter" element={<Newsletter />} />
     <Route path="mail" element={<MailSystem />} />
  </Route>
</Routes>

      </main>

      <Footer />
      <CookieConsent />
    </div>
  );
}
